import request from "@/utils/request";

// 物品补发列表
export function applicationListApi(data) {
    return request({
        url: "/admin/item_provision",
        method: "get",
        params: data
    });
}

// 物品补发-添加
export function addApplicationApi(data) {
  return request({
      url: "/admin/item_provision",
      method: "post",
      data
  });
}

// 物品补发-查看
export function viewApplicationApi(data) {
  return request({
      url: "/admin/item_provision/" + data ,
      method: "get",
      data
  });
}

// 物品补发-修改
export function fixApplicationApi(data) {
  return request({
      url: "/admin/item_provision/" + data.id ,
      method: "put",
      data
  });
}

// 物品补发-删除
export function delApplicationApi(data) {
  return request({
      url: "/admin/item_provision/" + data ,
      method: "delete",
      data
  });
}

// 物品补发-修改备注
export function remarkApi(data) {
  return request({
      url: "/admin/update_item_remark/" + data.id ,
      method: "put",
      data
  });
}

//  物品补发-提交审核(单条)
export function examineApi(data) {
  return request({
      url: "/admin/audit_item_provision/" + data.id ,
      method: "put",
      data
  });
}

// 物品补发-批量审核
export function lotExamineApi(data) {
  return request({
      url: "/admin/batch_item_audit" ,
      method: "put",
      data
  });
}

// 物品补发-批量通知
export function lotNoticeApi(data) {
  return request({
      url: "/admin/batch_item_ding_talk",
      method: "post",
      data
  });
}

// 物品补发-获取下拉框
export function getSelectionApi() {
  return request({
      url: "/admin/get_item_select",
      method: "get",
  });
}

// 获取钉钉通知人
export function getTalkPersonApi(data) {
  return request({
      url: "/admin/get_ding_talk_admin",
      method: "get",
      data
  });
}


